import { connect } from "react-redux";
import { fetchSpecialCollectionDetails } from "./state/actions";
import SpecialCollectionDetailsComponent from "./SpecialCollectionDetails";

const mapDispatchToProps = (dispatch) => ({
  fetchSpecialCollectionDetails: (pid) =>
    dispatch(fetchSpecialCollectionDetails(pid)),
});

const mapStateToProps = (state) => ({
  isLoading: state.specialCollectionDetailsFront.isLoading,
  specialCollection: state.specialCollectionDetailsFront.data, // ← Fixed: changed from 'series' to 'specialCollection'
  hasError: state.specialCollectionDetailsFront.hasError,
  error: state.specialCollectionDetailsFront.error,
});

export const SpecialCollectionDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialCollectionDetailsComponent);
